import { defineComponent, computed, resolveComponent, createElementBlock, openBlock, createBlock, createVNode, unref, createElementVNode, createTextVNode, toDisplayString, mergeProps, ref, watch, Fragment, renderList, createCommentVNode, normalizeClass, nextTick, withCtx, reactive, normalizeProps, guardReactiveProps, normalizeStyle, createSlots, renderSlot, useTemplateRef, withModifiers, mergeModels, useModel } from "vue";
import { buildParameterValue, ParameterDict, Blob, Integer, Type, ParameterList as ParameterList$1, Label, Size2D } from "@robovision/data";
import { ValidationBuilder, appendIntegerScalarValidation, scalarNumericBoundsFromDefinition, appendFloatScalarValidation } from "@robovision/rvai-base";
import useVuelidate from "@vuelidate/core";
import { useI18n } from "vue-i18n";
import { QItemSection, QIcon, QMenu, QList, QItem, QItemLabel } from "quasar";
const defaultOptions = () => ({
  extraComponents: []
});
let globalOptions = defaultOptions();
function provideOptions(options = defaultOptions()) {
  globalOptions = options;
}
function useOptions() {
  return globalOptions;
}
const _hoisted_1$d = { key: 0 };
const _hoisted_2$5 = {
  key: 0,
  class: "text-body3 multiline"
};
const _hoisted_3$1 = {
  key: 1,
  class: "column"
};
const _hoisted_4 = { class: "row no-wrap items-baseline q-pr-xs" };
const _hoisted_5 = { class: "text-subtitle3 multiline" };
const _hoisted_6 = {
  key: 2,
  class: "row no-wrap items-baseline"
};
const _hoisted_7 = { class: "row no-wrap items-baseline" };
const _hoisted_8 = { class: "single-line text-subtitle3 q-pl-xs" };
const _sfc_main$m = /* @__PURE__ */ defineComponent({
  __name: "ReadOnlyParam",
  props: {
    name: {
      required: true,
      type: String
    },
    value: {
      default: void 0,
      type: [Number, String, Boolean]
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    const { t: $t } = useI18n();
    const multiline = computed(() => typeof props.value === "string" && props.value.includes("\n"));
    return (_ctx, _cache) => {
      const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
      return __props.valueOnly ? (openBlock(), createElementBlock("div", _hoisted_1$d, [
        multiline.value ? (openBlock(), createElementBlock("div", _hoisted_2$5, [
          createVNode(_component_rv_ellipsis_text, {
            text: __props.value?.toString() ?? unref($t)("rvai-params.general.none")
          }, null, 8, ["text"])
        ])) : (openBlock(), createBlock(_component_rv_ellipsis_text, {
          key: 1,
          class: "text-body3",
          text: __props.value?.toString() ?? unref($t)("rvai-params.general.none")
        }, null, 8, ["text"]))
      ])) : multiline.value ? (openBlock(), createElementBlock("div", _hoisted_3$1, [
        createElementVNode("div", _hoisted_4, [
          createVNode(_component_rv_ellipsis_text, {
            class: "text-body3",
            text: __props.name
          }, null, 8, ["text"]),
          createTextVNode(" " + toDisplayString(unref($t)("rvai-params.general.symbols.colon")), 1)
        ]),
        createElementVNode("div", _hoisted_5, toDisplayString(__props.value ?? unref($t)("rvai-params.general.none")), 1)
      ])) : (openBlock(), createElementBlock("div", _hoisted_6, [
        createVNode(_component_rv_ellipsis_text, {
          class: "text-body3",
          text: __props.name
        }, null, 8, ["text"]),
        createElementVNode("div", _hoisted_7, [
          createTextVNode(toDisplayString(unref($t)("rvai-params.general.symbols.colon")) + " ", 1),
          createElementVNode("span", _hoisted_8, toDisplayString(__props.value ?? unref($t)("rvai-params.general.none")), 1)
        ])
      ]));
    };
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const ReadOnlyParam = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["__scopeId", "data-v-932d28a2"]]);
const _sfc_main$l = /* @__PURE__ */ defineComponent({
  __name: "BooleanParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: Boolean
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const i18nInstance = useI18n();
    const emit = __emit;
    const value = computed({
      get() {
        return props.modelValue;
      },
      set(value2) {
        const updated = value2 != null ? buildParameterValue("Boolean", value2) : void 0;
        emit("update:modelValue", updated);
      }
    });
    const valueLabel = computed(() => {
      switch (value.value) {
        case true:
          return i18nInstance.t("rvai-params.general.yes");
        case false:
          return i18nInstance.t("rvai-params.general.no");
        default:
          return i18nInstance.t("rvai-params.general.unset");
      }
    });
    const rules = computed(() => ({
      value: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).rules
    }));
    const state = computed(() => ({
      value: value.value
    }));
    useVuelidate(rules, state, { $autoDirty: true });
    return (_ctx, _cache) => {
      const _component_rv_toggle = resolveComponent("rv-toggle");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_toggle, {
        key: 0,
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
        class: "q-py-sm",
        disable: __props.disable,
        "info-text": __props.definition.description ?? void 0,
        label: __props.definition.name
      }, null, 8, ["modelValue", "disable", "info-text", "label"])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: valueLabel.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _sfc_main$k = /* @__PURE__ */ defineComponent({
  __name: "DictBoolParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: Object
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const i18nInstance = useI18n();
    const { t: $t } = i18nInstance;
    const emit = __emit;
    const allSelected = computed(() => {
      return [...props.modelValue?.values() ?? []].every((e) => e.value);
    });
    const hasSelected = computed(() => {
      return [...props.modelValue?.values() ?? []].some((e) => e.value);
    });
    const options = computed(() => {
      return props.definition.keys?.enum || [];
    });
    const selected = computed({
      get() {
        return [...props.modelValue?.entries() ?? []].filter(([, { value: value2 }]) => value2).map(([key]) => key);
      },
      set(value2) {
        const items = options.value.map((opt) => [opt, value2.includes(opt)]);
        const updatedValue = ParameterDict.new().addItems(items).build();
        emit("update:modelValue", updatedValue);
      }
    });
    const value = computed(() => {
      if (!hasSelected.value) return void 0;
      if (allSelected.value) return $t("rvai-params.general.allSelected");
      return [...props.modelValue?.entries() ?? []].filter(([, { value: value2 }]) => value2).map(([key]) => key).join("\n");
    });
    const rules = computed(() => ({
      selected: ValidationBuilder.withLabel(props.definition.name, i18nInstance).rules
    }));
    const v$ = useVuelidate(rules, { selected: selected.value }, { $autoDirty: true });
    return (_ctx, _cache) => {
      const _component_rv_multiple_select = resolveComponent("rv-multiple-select");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_multiple_select, {
        key: 0,
        modelValue: selected.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => selected.value = $event),
        "all-selected-text": unref($t)("rvai-params.general.allSelected"),
        class: "dict-param full-width",
        disable: __props.disable,
        "info-text": __props.definition.description,
        label: __props.definition.name,
        options: options.value,
        validation: unref(v$).selected,
        "with-chips": ""
      }, null, 8, ["modelValue", "all-selected-text", "disable", "info-text", "label", "options", "validation"])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const byteToHex = [];
for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 256).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    if (typeof crypto === "undefined" || !crypto.getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    getRandomValues = crypto.getRandomValues.bind(crypto);
  }
  return getRandomValues(rnds8);
}
const randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const native = { randomUUID };
function v4(options, buf, offset) {
  if (native.randomUUID && true && !options) {
    return native.randomUUID();
  }
  options = options || {};
  const rnds = options.random ?? options.rng?.() ?? rng();
  if (rnds.length < 16) {
    throw new Error("Random bytes length must be >= 16");
  }
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  return unsafeStringify(rnds);
}
const _sfc_main$j = /* @__PURE__ */ defineComponent({
  __name: "DictKeyValueParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: Object
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const i18nInstance = useI18n();
    const { t: $t } = i18nInstance;
    function storedValueToInputString(stored) {
      if (stored === null) return "";
      if (typeof stored === "string") return stored;
      if (typeof stored === "number" || typeof stored === "bigint") {
        return String(stored);
      }
      if (typeof stored === "boolean") return String(stored);
      if (typeof stored === "object" && "value" in stored) {
        const inner = stored.value;
        return String(inner);
      }
      return String(stored);
    }
    function coerceDictValueForEmit(raw) {
      const valuesDef = props.definition.values;
      const trimmed = raw.trim();
      if (valuesDef.type === "Integer") {
        if (trimmed === "") return "";
        const n = Number(trimmed);
        if (Number.isFinite(n)) return buildParameterValue("Integer", n);
        return raw;
      }
      if (valuesDef.type === "Float") {
        if (trimmed === "") return "";
        const n = Number(trimmed);
        if (Number.isFinite(n)) return buildParameterValue("Float", n);
        return raw;
      }
      return raw;
    }
    function getDefaultValue() {
      const emptyValue = {
        id: v4(),
        row: ["", ""]
      };
      const entries = [...props.modelValue?.entries() ?? []];
      if (entries.length > 0) {
        return entries.map(([key, node]) => ({
          id: node.id,
          row: [key, storedValueToInputString(node.value)]
        }));
      }
      return [emptyValue];
    }
    const rows = ref(getDefaultValue());
    function removeRow(rowIndex) {
      rows.value = rows.value.filter((_, i) => i !== rowIndex);
      updateValue();
    }
    function setDictValue(value2, rowIndex) {
      const id = rows.value[rowIndex] ? rows.value[rowIndex].id : v4();
      rows.value[rowIndex] = {
        id,
        row: value2
      };
      updateValue();
    }
    async function updateValue() {
      const pairs = rows.value.filter(({ row }) => {
        const [key, value2] = row;
        return !!key || !!value2;
      }).map(({ row }) => {
        const [key, valueStr] = row;
        return [key, coerceDictValueForEmit(valueStr)];
      });
      const updatedValue = ParameterDict.new().addItems(pairs).build();
      emit("update:modelValue", updatedValue);
      await nextTick();
      v$.value.$validate();
    }
    const value = computed(() => {
      const entries = [...props.modelValue?.entries() ?? []];
      if (!entries.length || entries.every(([key]) => !key)) return void 0;
      return entries.map(([key, node]) => `${key}: ${storedValueToInputString(node.value)}`).join("\n");
    });
    const rules = computed(() => rows.value.reduce((acc, {
      id,
      row: [key, value2]
    }) => ({
      ...acc,
      [`${id}-key`]: ValidationBuilder.withLabel(props.definition.name, i18nInstance).custom(
        (key2) => {
          const equalKeysCount = rows.value.filter(({ row }) => {
            return row[0] === key2;
          }).length;
          return equalKeysCount < 2;
        },
        "rvai-params.errors.duplicatedKeys",
        [],
        "duplicatedKeys"
      ).custom(
        (key2) => {
          if (value2) return !!key2.trim();
          return true;
        },
        "rvai-params.errors.bothAreRequired",
        [],
        "requiredIf"
      ).custom(
        (key2) => {
          if (rows.value.length > 1) return !!key2.trim();
          return true;
        },
        "rvai-params.errors.bothAreRequired",
        [],
        "requiredIfHasOtherKeyValue"
      ).maxLength(props.definition.keys?.maxLength).minLength(props.definition.keys?.minLength).oneOfRegexes(props.definition.keys?.pattern?.map((p) => new RegExp(p)) ?? []).rules,
      [`${id}-value`]: (() => {
        const valuesDef = props.definition.values;
        let valueBuilder = ValidationBuilder.withLabel(props.definition.name, i18nInstance).custom(
          (value3) => {
            if (key && !props.definition.values.optional) return !!value3.trim();
            return true;
          },
          "rvai-params.errors.bothAreRequired",
          [],
          "requiredIf"
        );
        if (valuesDef.type === "Integer") {
          valueBuilder = appendIntegerScalarValidation(
            valueBuilder,
            scalarNumericBoundsFromDefinition(valuesDef)
          );
        } else if (valuesDef.type === "Float") {
          valueBuilder = appendFloatScalarValidation(
            valueBuilder,
            scalarNumericBoundsFromDefinition(valuesDef)
          );
        }
        return valueBuilder.maxLength("maxLength" in valuesDef ? valuesDef.maxLength : null).minLength("minLength" in valuesDef ? valuesDef.minLength : null).oneOfRegexes(
          "pattern" in valuesDef ? valuesDef.pattern?.map((p) => new RegExp(p)) ?? [] : []
        ).rules;
      })()
    }), {}));
    const dataForValidation = computed(() => rows.value.reduce((acc, {
      id,
      row: [key, value2]
    }) => ({
      ...acc,
      [`${id}-key`]: key,
      [`${id}-value`]: value2
    }), {}));
    const v$ = useVuelidate(rules, dataForValidation, { $autoDirty: true });
    watch(() => props.modelValue, (curr, prev) => {
      const previousEntries = [...prev?.entries() ?? []];
      if (!previousEntries.length) return;
      const currentEntries = [...curr?.entries() ?? []];
      if (!currentEntries.length) {
        rows.value = getDefaultValue();
        updateValue();
      }
    });
    return (_ctx, _cache) => {
      const _component_rv_combined_inputs = resolveComponent("rv-combined-inputs");
      const _component_rv_button = resolveComponent("rv-button");
      return !__props.readonly ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(rows.value, (v, i) => {
        return openBlock(), createElementBlock("div", {
          key: v.id,
          class: "dict-key-value-param row full-width no-wrap justify-between items-start"
        }, [
          createVNode(_component_rv_combined_inputs, {
            class: normalizeClass(["dict-key-value-param__row", {
              "q-mb-md": rows.value.length - 1 !== i
            }]),
            "data-automation": "dict-key-value-param__row",
            disable: __props.disable,
            hint: "",
            "info-text": __props.definition.description,
            label: i ? "" : __props.definition.name,
            "model-value": v.row,
            placeholders: [unref($t)("rvai-params.general.key"), unref($t)("rvai-params.general.value")],
            readonly: __props.readonly,
            separator: ":",
            "show-optional-label": __props.definition.optional,
            validation: [unref(v$)[`${v.id}-key`], unref(v$)[`${v.id}-value`]],
            "onUpdate:modelValue": ($event) => setDictValue($event, i)
          }, null, 8, ["class", "disable", "info-text", "label", "model-value", "placeholders", "readonly", "show-optional-label", "validation", "onUpdate:modelValue"]),
          !__props.readonly ? (openBlock(), createBlock(_component_rv_button, {
            key: 0,
            class: normalizeClass(["dict-key-value-param__btn q-ml-sm", {
              "dict-key-value-param__btn--first-row": !i
            }]),
            "data-automation": "dict-key-value-param__add",
            disable: !v.row[0].length || !v.row[1].length || !!rows.value[i + 1],
            icon: "mdi-plus",
            size: "sm",
            tertiary: "",
            onClick: ($event) => setDictValue(["", ""], i + 1)
          }, null, 8, ["class", "disable", "onClick"])) : createCommentVNode("", true),
          !__props.readonly ? (openBlock(), createBlock(_component_rv_button, {
            key: 1,
            class: normalizeClass(["dict-key-value-param__btn q-ml-sm", {
              "dict-key-value-param__btn--first-row": !i
            }]),
            "data-automation": "dict-key-value-param__remove",
            disable: rows.value.length === 1,
            icon: "mdi-delete",
            size: "sm",
            tertiary: "",
            onClick: ($event) => removeRow(i)
          }, null, 8, ["class", "disable", "onClick"])) : createCommentVNode("", true)
        ]);
      }), 128)) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const DictKeyValueParam = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["__scopeId", "data-v-60c45adf"]]);
const _sfc_main$i = /* @__PURE__ */ defineComponent({
  __name: "EnumParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: String
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const value = computed({
      get() {
        return props.modelValue;
      },
      set(value2) {
        const updated = value2 != null ? buildParameterValue("Text", value2) : value2;
        emit("update:modelValue", updated);
      }
    });
    const i18nInstance = useI18n();
    const rules = computed(() => ({
      value: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).rules
    }));
    const state = computed(() => ({
      value: value.value
    }));
    const v$ = useVuelidate(rules, state, { $autoDirty: true });
    return (_ctx, _cache) => {
      const _component_rv_select = resolveComponent("rv-select");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_select, {
        key: 0,
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
        disable: __props.disable,
        "info-text": __props.definition.description,
        label: __props.definition.name,
        options: __props.definition.enum ?? [],
        readonly: __props.readonly,
        "show-optional-label": __props.definition.optional,
        validation: unref(v$).value
      }, null, 8, ["modelValue", "disable", "info-text", "label", "options", "readonly", "show-optional-label", "validation"])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _hoisted_1$c = {
  key: 0,
  class: "file-param"
};
const _sfc_main$h = /* @__PURE__ */ defineComponent({
  __name: "FileParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: Object
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const file = ref([]);
    const value = computed(() => file.value && file.value.length ? file.value[0].name : void 0);
    async function updateValue(value2) {
      file.value = value2;
      if (value2 && value2.length) {
        emit("update:modelValue", await Blob.fromFile(value2[0]));
      } else {
        clearAll();
      }
    }
    function clearAll() {
      emit("update:modelValue", void 0);
    }
    return (_ctx, _cache) => {
      const _component_rv_dropzone = resolveComponent("rv-dropzone");
      return !__props.readonly ? (openBlock(), createElementBlock("div", _hoisted_1$c, [
        createVNode(_component_rv_dropzone, {
          "allowed-extensions": props.definition.extension,
          disable: __props.disable,
          "max-files": 1,
          "model-value": __props.modelValue,
          multiple: false,
          onClear: clearAll,
          "onUpdate:modelValue": updateValue
        }, null, 8, ["allowed-extensions", "disable", "model-value"])
      ])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _hoisted_1$b = {
  key: 0,
  class: "row no-wrap items-end"
};
const _sfc_main$g = /* @__PURE__ */ defineComponent({
  __name: "FloatParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: [Object, Number]
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const i18nInstance = useI18n();
    const isSlider = computed(() => props.definition.widget === "slider" && props.definition.maximum != null && props.definition.minimum != null);
    const valueRef = ref(typeof props.modelValue === "number" ? props.modelValue : props.modelValue?.value);
    const isPercentage = computed(() => props.definition.widget === "percentage");
    const value = computed({
      get() {
        return isPercentage.value && valueRef.value ? valueRef.value * 100 : valueRef.value;
      },
      set(value2) {
        valueRef.value = isPercentage.value && value2 ? value2 / 100 : value2;
        if (valueRef.value == null) {
          emit("update:modelValue", void 0);
        } else {
          const parsed = Number(valueRef.value);
          if (!isNaN(parsed)) {
            const updated = buildParameterValue("Float", parsed);
            emit("update:modelValue", updated);
          }
        }
      }
    });
    const numericBounds = computed(() => scalarNumericBoundsFromDefinition(props.definition));
    const rules = computed(() => ({
      value: appendFloatScalarValidation(
        ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional),
        numericBounds.value
      ).rules
    }));
    const state = computed(() => ({
      value: valueRef.value
    }));
    const v$ = useVuelidate(rules, state, { $autoDirty: true });
    watch(
      () => props.modelValue,
      () => {
        const newValue = typeof props.modelValue === "number" ? props.modelValue : props.modelValue?.value;
        if (Number(valueRef.value) !== Number(newValue)) {
          valueRef.value = newValue;
        }
      }
    );
    return (_ctx, _cache) => {
      const _component_rv_slider = resolveComponent("rv-slider");
      const _component_rv_input = resolveComponent("rv-input");
      return !__props.readonly ? (openBlock(), createElementBlock("div", _hoisted_1$b, [
        isSlider.value ? (openBlock(), createBlock(_component_rv_slider, {
          key: 0,
          modelValue: value.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
          class: "full-width",
          disable: __props.disable,
          float: "",
          "info-text": __props.definition.description,
          "input-decimals": 3,
          label: __props.definition.name,
          max: __props.definition.maximum,
          min: __props.definition.minimum,
          readonly: __props.readonly,
          "show-optional-label": __props.definition.optional,
          step: 0.1,
          suffix: isPercentage.value ? "%" : void 0,
          validation: unref(v$).value,
          "with-input": ""
        }, null, 8, ["modelValue", "disable", "info-text", "label", "max", "min", "readonly", "show-optional-label", "suffix", "validation"])) : (openBlock(), createBlock(_component_rv_input, {
          key: 1,
          modelValue: value.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => value.value = $event),
          class: "full-width",
          disable: __props.disable,
          "info-text": __props.definition.description,
          label: __props.definition.name,
          readonly: __props.readonly,
          "show-optional-label": __props.definition.optional,
          suffix: isPercentage.value ? "%" : void 0,
          validation: unref(v$).value
        }, null, 8, ["modelValue", "disable", "info-text", "label", "readonly", "show-optional-label", "suffix", "validation"]))
      ])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _sfc_main$f = /* @__PURE__ */ defineComponent({
  __name: "FloatRangeParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: [Object]
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const i18nInstance = useI18n();
    const defaultValues = computed(() => Object.assign({
      lowerBound: 0.3,
      lowerInclusive: false,
      upperBound: 0.5,
      upperInclusive: false
    }, props.definition.default));
    const valueRef = ref(getRangeValue(props.modelValue));
    const value = computed({
      get() {
        return valueRef.value;
      },
      set(value2) {
        valueRef.value = value2;
        emit(
          "update:modelValue",
          buildParameterValue("FloatRange", {
            lowerBound: valueRef.value.min,
            lowerInclusive: props.modelValue?.lowerInclusive ?? defaultValues.value.lowerInclusive,
            upperBound: valueRef.value.max,
            upperInclusive: props.modelValue?.upperInclusive ?? defaultValues.value.upperInclusive
          })
        );
      }
    });
    const maxValue = computed(() => props.definition.exclusiveMaximum ?? props.definition.maximum);
    const hasMaxValue = computed(() => maxValue.value != null);
    const maxValueExclusive = computed(() => props.definition.exclusiveMaximum != null);
    const minValue = computed(() => props.definition.minimum ?? props.definition.exclusiveMinimum);
    const hasMinValue = computed(() => minValue.value != null);
    const minValueExclusive = computed(() => props.definition.exclusiveMinimum != null);
    const rules = computed(() => ({
      max: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).numeric.decimal.maxValueIf(hasMaxValue.value, maxValue.value, !maxValueExclusive.value).rules,
      min: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).numeric.decimal.minValueIf(hasMinValue.value, minValue.value, !minValueExclusive.value).rules
    }));
    const state = computed(() => ({
      max: valueRef.value.max,
      min: valueRef.value.min
    }));
    const v$ = useVuelidate(rules, state, { $autoDirty: true });
    function getRangeValue(value2) {
      return {
        max: value2?.upperBound ?? defaultValues.value.upperBound,
        min: value2?.lowerBound ?? defaultValues.value.lowerBound
      };
    }
    watch(
      () => props.modelValue,
      (newValue) => {
        valueRef.value = getRangeValue(newValue);
      }
    );
    return (_ctx, _cache) => {
      const _component_rv_range = resolveComponent("rv-range");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_range, {
        key: 0,
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
        class: "full-width",
        disable: __props.disable,
        "info-text": __props.definition.description ?? void 0,
        "input-decimals": 3,
        label: __props.definition.name,
        max: __props.definition.maximum ?? void 0,
        min: __props.definition.minimum ?? void 0,
        "show-optional-label": __props.definition.optional,
        step: 0.1,
        validation: unref(v$).value,
        "with-input": ""
      }, null, 8, ["modelValue", "disable", "info-text", "label", "max", "min", "show-optional-label", "validation"])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: props.modelValue ? `${props.modelValue.lowerBound} - ${props.modelValue.upperBound}` : void 0,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _hoisted_1$a = {
  key: 0,
  class: "text-small text-grey-1 q-pt-md"
};
const _sfc_main$e = /* @__PURE__ */ defineComponent({
  __name: "GroupParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: Object
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const expanded = ref(false);
    function onUpdateParam(key, value) {
      emit("update:modelValue", {
        ...props.modelValue && props.modelValue,
        [key]: value
      });
    }
    return (_ctx, _cache) => {
      const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
      const _component_rv_parameter = resolveComponent("rv-parameter");
      const _component_rv_expansion_item = resolveComponent("rv-expansion-item");
      return openBlock(), createBlock(_component_rv_expansion_item, {
        modelValue: expanded.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => expanded.value = $event),
        class: "rv-group-param",
        dense: "",
        "switch-toggle-side": ""
      }, {
        header: withCtx(() => [
          createVNode(unref(QItemSection), null, {
            default: withCtx(() => [
              createVNode(_component_rv_ellipsis_text, {
                class: "text-subtitle3",
                disable: __props.disable,
                text: __props.definition.name
              }, null, 8, ["disable", "text"])
            ]),
            _: 1
          })
        ]),
        default: withCtx(() => [
          __props.definition.description ? (openBlock(), createElementBlock("div", _hoisted_1$a, toDisplayString(__props.definition.description), 1)) : createCommentVNode("", true),
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.definition.fields, (param, key) => {
            return openBlock(), createBlock(_component_rv_parameter, {
              key,
              class: "q-my-md q-mx-sm",
              definition: param,
              disable: __props.disable,
              "model-value": __props.modelValue ? __props.modelValue[key] : void 0,
              readonly: __props.readonly,
              "value-only": __props.valueOnly,
              "onUpdate:modelValue": ($event) => onUpdateParam(key, $event)
            }, null, 8, ["definition", "disable", "model-value", "readonly", "value-only", "onUpdate:modelValue"]);
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});
const _hoisted_1$9 = {
  key: 0,
  class: "row no-wrap items-end"
};
const _sfc_main$d = /* @__PURE__ */ defineComponent({
  __name: "IntegerParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: [Object, Number, BigInt]
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const i18nInstance = useI18n();
    function isInteger64(value2) {
      return typeof value2 === "bigint" || value2 instanceof Integer && value2.type === Type.Integer64;
    }
    function toNumber(value2) {
      const raw = value2 instanceof Integer ? value2.value : value2;
      return raw == null ? void 0 : Number(raw);
    }
    const is64Bit = ref(isInteger64(props.modelValue));
    const valueRef = ref(toNumber(props.modelValue));
    const value = computed({
      get() {
        return valueRef.value;
      },
      set(value2) {
        valueRef.value = value2;
        if (value2 == null) {
          emit("update:modelValue", void 0);
          return;
        }
        const parsed = Number(value2);
        if (!Number.isInteger(parsed)) return;
        emit("update:modelValue", is64Bit.value ? buildParameterValue("Integer", BigInt(parsed)) : buildParameterValue("Integer", parsed));
      }
    });
    const isSlider = computed(() => props.definition.widget === "slider" && props.definition.maximum != null && props.definition.minimum != null);
    const numericBounds = computed(() => scalarNumericBoundsFromDefinition(props.definition));
    const rules = computed(() => ({
      value: appendIntegerScalarValidation(
        ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional),
        numericBounds.value
      ).rules
    }));
    const state = computed(() => ({
      value: value.value
    }));
    const v$ = useVuelidate(rules, state, { $autoDirty: true });
    watch(
      () => props.modelValue,
      () => {
        if (isInteger64(props.modelValue)) {
          is64Bit.value = true;
        }
        const newValue = toNumber(props.modelValue);
        if (Number(valueRef.value) !== Number(newValue)) {
          valueRef.value = newValue;
        }
      }
    );
    return (_ctx, _cache) => {
      const _component_rv_slider = resolveComponent("rv-slider");
      const _component_rv_input = resolveComponent("rv-input");
      return !__props.readonly ? (openBlock(), createElementBlock("div", _hoisted_1$9, [
        isSlider.value ? (openBlock(), createBlock(_component_rv_slider, {
          key: 0,
          modelValue: value.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
          class: "full-width",
          disable: __props.disable,
          "info-text": __props.definition.description,
          label: __props.definition.name,
          max: __props.definition.maximum,
          min: __props.definition.minimum,
          readonly: __props.readonly,
          "show-optional-label": __props.definition.optional,
          validation: unref(v$).value,
          "with-input": ""
        }, null, 8, ["modelValue", "disable", "info-text", "label", "max", "min", "readonly", "show-optional-label", "validation"])) : (openBlock(), createBlock(_component_rv_input, {
          key: 1,
          modelValue: value.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => value.value = $event),
          class: "full-width",
          disable: __props.disable,
          "info-text": __props.definition.description,
          label: __props.definition.name,
          readonly: __props.readonly,
          "show-optional-label": __props.definition.optional,
          validation: unref(v$).value
        }, null, 8, ["modelValue", "disable", "info-text", "label", "readonly", "show-optional-label", "validation"]))
      ])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _hoisted_1$8 = { key: 1 };
const _hoisted_2$4 = { class: "no-wrap flex-inline max-width-full" };
const _sfc_main$c = /* @__PURE__ */ defineComponent({
  __name: "ListParam",
  props: {
    dataDependencies: {
      default: void 0,
      type: Object
    },
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: Object
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const i18nInstance = useI18n();
    const { t: $t } = i18nInstance;
    const emit = __emit;
    const classes = computed(() => {
      return props.dataDependencies?.classes ?? [];
    });
    const options = computed(() => {
      return classes.value.map((c) => ({
        color: c.color,
        label: c.name,
        value: c.id
      }));
    });
    const selectedRef = ref(getSelectedOptionsValue(props.modelValue));
    const selected = computed({
      get() {
        return selectedRef.value;
      },
      set(value) {
        selectedRef.value = value;
        const updatedValue = ParameterList$1.new().addValues(value.map((o) => [o.value, new Label(o.value)])).build();
        emit("update:modelValue", updatedValue);
      }
    });
    const hasSelected = computed(() => {
      return selected.value.length > 0;
    });
    const allSelected = computed(() => {
      return classes.value.length > 0 && classes.value.every((c) => selected.value.some((s) => s.value === c.id));
    });
    const rules = computed(() => ({
      selected: ValidationBuilder.withLabel(props.definition.name, i18nInstance).custom(
        (value) => props.definition.optional || value.length > 0,
        "rvai-params.errors.selectionRequired"
      ).rules
    }));
    const state = computed(() => ({
      selected: selected.value
    }));
    const v$ = useVuelidate(rules, state, { $autoDirty: true });
    function getSelectOptionValue(parameterNode) {
      return {
        color: classes.value.find((e) => e.id === parameterNode.key)?.color,
        label: parameterNode.key,
        value: parameterNode.key
      };
    }
    function getSelectedOptionsValue(value) {
      return (value ?? []).map(getSelectOptionValue);
    }
    watch(
      () => props.dataDependencies,
      () => {
        selectedRef.value = getSelectedOptionsValue(props.modelValue);
      }
    );
    watch(
      () => props.modelValue,
      (newValue) => {
        selectedRef.value = getSelectedOptionsValue(newValue);
      }
    );
    return (_ctx, _cache) => {
      const _component_rv_multiple_select = resolveComponent("rv-multiple-select");
      const _component_rv_bullet = resolveComponent("rv-bullet");
      const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_multiple_select, {
        key: 0,
        modelValue: selected.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => selected.value = $event),
        "all-selected-text": unref($t)("rvai-params.general.allSelected"),
        class: "full-width",
        disable: __props.disable,
        "info-text": __props.definition.description ?? void 0,
        label: __props.definition.name,
        options: options.value,
        validation: unref(v$).selected,
        "with-chips": ""
      }, null, 8, ["modelValue", "all-selected-text", "disable", "info-text", "label", "options", "validation"])) : (openBlock(), createElementBlock("div", _hoisted_1$8, [
        hasSelected.value && !allSelected.value ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(selected.value, (option) => {
          return openBlock(), createElementBlock("div", {
            key: option.value,
            class: "full-width q-pb-sm"
          }, [
            createElementVNode("div", _hoisted_2$4, [
              createVNode(_component_rv_bullet, {
                class: "q-pr-sm",
                color: option.color,
                "is-tooltip-shown": false,
                size: 8
              }, null, 8, ["color"]),
              createVNode(_component_rv_ellipsis_text, {
                class: "zero-min-width",
                text: option.value
              }, null, 8, ["text"])
            ])
          ]);
        }), 128)) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
          name: __props.definition.name,
          value: allSelected.value ? unref($t)("rvai-params.general.allSelected") : void 0,
          "value-only": __props.valueOnly
        }), null, 16, ["name", "value", "value-only"]))
      ]));
    };
  }
});
const ListParam = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["__scopeId", "data-v-0c7b8b9d"]]);
const _sfc_main$b = /* @__PURE__ */ defineComponent({
  __name: "Size2DParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: Object
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const i18nInstance = useI18n();
    const currentValue = reactive({
      height: String(props.modelValue?.height ?? ""),
      width: String(props.modelValue?.width ?? "")
    });
    const arrayValue = computed({
      get() {
        return [currentValue.width, currentValue.height];
      },
      set(value) {
        const [width, height] = value;
        Object.assign(currentValue, {
          height,
          width
        });
        emitUpdate();
      }
    });
    const readOnlyValue = computed(() => {
      if (!props.modelValue) return void 0;
      const {
        height,
        width
      } = props.modelValue;
      return `${width} x ${height}`;
    });
    watch(() => props.modelValue, (value) => {
      Object.assign(currentValue, {
        height: String(value?.height ?? ""),
        width: String(value?.width ?? "")
      });
    });
    function emitUpdate() {
      const {
        height,
        width
      } = currentValue;
      if (!height || !width) {
        return emit("update:modelValue", void 0);
      }
      const parsedHeight = Number(height);
      const parsedWidth = Number(width);
      if (parsedHeight != null && !isNaN(parsedHeight) && parsedWidth != null && !isNaN(parsedWidth)) {
        emit("update:modelValue", new Size2D(parsedHeight, parsedWidth));
      } else {
        return emit("update:modelValue", void 0);
      }
    }
    const rules = computed(() => ({
      height: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).numeric.minValueIf(!props.definition.optional && props.definition.minSize?.width != null, props.definition.minSize?.width).maxValueIf(!props.definition.optional && props.definition.maxSize?.width != null, props.definition.maxSize?.width).equalTo(props.definition.exactSize?.width).rules,
      width: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).numeric.minValueIf(!props.definition.optional && props.definition.minSize?.width != null, props.definition.minSize?.width).maxValueIf(!props.definition.optional && props.definition.maxSize?.width != null, props.definition.maxSize?.width).equalTo(props.definition.exactSize?.width).rules
    }));
    const v$ = useVuelidate(
      rules,
      currentValue,
      { $autoDirty: true }
    );
    return (_ctx, _cache) => {
      const _component_rv_combined_inputs = resolveComponent("rv-combined-inputs");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_combined_inputs, {
        key: 0,
        modelValue: arrayValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => arrayValue.value = $event),
        class: "size2d-param full-width",
        disable: __props.disable,
        hint: "Width x height",
        "info-text": __props.definition.description,
        label: __props.definition.name,
        readonly: __props.readonly,
        separator: "x",
        validation: [unref(v$).width, unref(v$).height]
      }, null, 8, ["modelValue", "disable", "info-text", "label", "readonly", "validation"])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: readOnlyValue.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const Size2DParam = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["__scopeId", "data-v-deffc5d2"]]);
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  __name: "TextParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: String
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const VALID_TYPES = [
      "text",
      "password",
      "textarea",
      "time",
      "date",
      "datetime-local"
    ];
    const props = __props;
    const emit = __emit;
    const i18nInstance = useI18n();
    const value = computed({
      get() {
        return props.modelValue;
      },
      set(value2) {
        const updated = value2 ? buildParameterValue("Text", value2) : null;
        emit("update:modelValue", updated);
      }
    });
    const type = computed(() => {
      const { widget } = props.definition;
      if (widget && VALID_TYPES.includes(widget)) {
        return widget;
      } else {
        return void 0;
      }
    });
    const rules = computed(() => ({
      value: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).maxLength(props.definition?.maxLength).minLength(props.definition?.minLength).oneOfRegexes(props.definition?.pattern?.map((p) => new RegExp(p)) ?? []).rules
    }));
    const state = computed(() => ({
      value: value.value
    }));
    const v$ = useVuelidate(rules, state, { $autoDirty: true });
    return (_ctx, _cache) => {
      const _component_rv_input = resolveComponent("rv-input");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_input, {
        key: 0,
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
        disable: __props.disable,
        "info-text": __props.definition.description,
        label: __props.definition.name,
        readonly: __props.readonly,
        "show-optional-label": __props.definition.optional,
        type: type.value,
        validation: unref(v$).value
      }, null, 8, ["modelValue", "disable", "info-text", "label", "readonly", "show-optional-label", "type", "validation"])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _sfc_main$9 = defineComponent({
  components: {
    QIcon
  },
  inheritAttrs: false,
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    hideLabel: {
      default: false,
      type: Boolean
    }
  }
});
const _hoisted_1$7 = { class: "row no-wrap items-center" };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
  const _component_rv_tooltip = resolveComponent("rv-tooltip");
  const _component_QIcon = resolveComponent("QIcon");
  return openBlock(), createElementBlock("div", _hoisted_1$7, [
    !_ctx.hideLabel ? (openBlock(), createBlock(_component_rv_ellipsis_text, mergeProps({ key: 0 }, _ctx.$attrs, {
      class: "text-subtitle3",
      disable: _ctx.disable,
      text: _ctx.definition.name
    }), null, 16, ["disable", "text"])) : createCommentVNode("", true),
    _ctx.definition.description ? (openBlock(), createBlock(_component_QIcon, {
      key: 1,
      class: "info-icon q-mx-xs",
      color: "black-1",
      name: "info",
      size: "16px"
    }, {
      default: withCtx(() => [
        createVNode(_component_rv_tooltip, null, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.definition.description), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })) : createCommentVNode("", true)
  ]);
}
const ParamTitle = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$1]]);
const _hoisted_1$6 = { key: 0 };
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "UnsupportedParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: [Number, Object, String, Boolean]
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    const value = computed(() => {
      return JSON.stringify(props.modelValue, null, 2) ?? "(Unsupported type)";
    });
    return (_ctx, _cache) => {
      return !__props.readonly ? (openBlock(), createElementBlock("div", _hoisted_1$6, [
        createVNode(ParamTitle, {
          definition: __props.definition,
          disable: __props.disable
        }, null, 8, ["definition", "disable"]),
        createElementVNode("span", {
          class: normalizeClass(["text-body3 text-grey-1", { "disabled": __props.disable }])
        }, " Unsupported parameter type (" + toDisplayString(__props.definition.type) + ") ", 3)
      ])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: value.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "UriParam",
  props: {
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: String
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const isWebhookUrl = computed(() => {
      const { widget } = props.definition;
      return widget === "webhook";
    });
    const url = ref(props.modelValue);
    const emit = __emit;
    function onBlur() {
      try {
        const urlObject = url.value ? buildParameterValue("URI", url.value) : void 0;
        url.value = urlObject ? urlObject.toString() : "";
        emit("update:modelValue", urlObject);
      } catch (err) {
        console.log(err);
      }
    }
    const uriRegex = /(?<scheme>.*):\/\/(?<authority>[^/]*)(?:\/(?<path>[^/?]*))?(?:\?(?<query>[^#]*))?(?:#(?<fragment>.*))?/;
    const urlRegex = /^https?:\/\/(\S+(?::\S+@))?([a-zA-Z0-9-:]+\.)*[a-zA-Z0-9-:]{2,}(\/[^\s]*)?$/;
    const rules = computed(() => ({
      value: ValidationBuilder.withLabel(props.definition.name).requiredIf(!props.definition.optional).regex(isWebhookUrl.value ? urlRegex : uriRegex).rules
    }));
    const state = computed(() => ({
      value: url.value
    }));
    const v$ = useVuelidate(rules, state, { $autoDirty: true });
    return (_ctx, _cache) => {
      const _component_rv_input = resolveComponent("rv-input");
      return !__props.readonly ? (openBlock(), createBlock(_component_rv_input, {
        key: 0,
        modelValue: url.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => url.value = $event),
        "bottom-slots": "",
        disable: __props.disable,
        "info-text": __props.definition.description,
        label: __props.definition.name,
        readonly: __props.readonly,
        "show-optional-label": __props.definition.optional,
        validation: unref(v$).value,
        onBlur
      }, null, 8, ["modelValue", "disable", "info-text", "label", "readonly", "show-optional-label", "validation"])) : (openBlock(), createBlock(ReadOnlyParam, mergeProps({ key: 1 }, _ctx.$attrs, {
        name: __props.definition.name,
        value: url.value,
        "value-only": __props.valueOnly
      }), null, 16, ["name", "value", "value-only"]));
    };
  }
});
const ComponentMap = {
  Blob: _sfc_main$h,
  Boolean: _sfc_main$l,
  // these 2 components are not implemented for the correct
  // param type. they should be revisited if they are ever needed.
  // Box2D: Box2DParam,
  // Box3D: Box3DParam,
  Float: _sfc_main$g,
  FloatRange: _sfc_main$f,
  Integer: _sfc_main$d,
  List: ListParam,
  Object: _sfc_main$e,
  Size2D: Size2DParam,
  Text: _sfc_main$a,
  URI: _sfc_main$7
};
function mapToComponent(definition, extraComponents = []) {
  for (const entry of extraComponents) {
    if (entry.supports(definition)) {
      return entry.component;
    }
  }
  if (definition.type === "Text" && definition.enum?.length) {
    return _sfc_main$i;
  }
  if (definition.type === "Dict" && definition.values.type === "Boolean" && definition.keys?.enum != null) {
    return _sfc_main$k;
  }
  if (definition.type === "Dict" && (definition.values.type === "Text" || definition.values.type === "Integer" || definition.values.type === "Float")) {
    return DictKeyValueParam;
  }
  const component = ComponentMap[definition.type];
  if (!component) {
    console.warn(`Could not find component for param ${definition.name} with type ${definition.type}`);
    return _sfc_main$8;
  }
  return component;
}
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "Parameter",
  props: {
    dataDependencies: {
      default: void 0,
      type: Object
    },
    definition: {
      required: true,
      type: Object
    },
    disable: {
      default: false,
      type: Boolean
    },
    modelValue: {
      default: void 0,
      type: [Number, Object, String, Boolean]
    },
    /**
     * Daemon parameter requires project to be known.
     *
     * If it is not provided, the daemon parameter loads the project
     * based on the projectName route parameter.
     */
    project: {
      default: void 0,
      type: Object
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const { extraComponents } = useOptions();
    const ParamComponent = mapToComponent(props.definition, extraComponents);
    function onUpdateModelValue(value, isDefaultValue) {
      emit("update:modelValue", value, isDefaultValue);
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(ParamComponent), {
        "data-dependencies": __props.dataDependencies,
        definition: __props.definition,
        disable: __props.disable,
        "model-value": __props.modelValue,
        project: __props.project,
        readonly: __props.readonly,
        "value-only": __props.valueOnly,
        "onUpdate:modelValue": onUpdateModelValue
      }, null, 8, ["data-dependencies", "definition", "disable", "model-value", "project", "readonly", "value-only"]);
    };
  }
});
var HttpStatusCode;
(function(HttpStatusCode2) {
  HttpStatusCode2[HttpStatusCode2["CONTINUE"] = 100] = "CONTINUE";
  HttpStatusCode2[HttpStatusCode2["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
  HttpStatusCode2[HttpStatusCode2["PROCESSING"] = 102] = "PROCESSING";
  HttpStatusCode2[HttpStatusCode2["OK"] = 200] = "OK";
  HttpStatusCode2[HttpStatusCode2["CREATED"] = 201] = "CREATED";
  HttpStatusCode2[HttpStatusCode2["ACCEPTED"] = 202] = "ACCEPTED";
  HttpStatusCode2[HttpStatusCode2["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
  HttpStatusCode2[HttpStatusCode2["NO_CONTENT"] = 204] = "NO_CONTENT";
  HttpStatusCode2[HttpStatusCode2["RESET_CONTENT"] = 205] = "RESET_CONTENT";
  HttpStatusCode2[HttpStatusCode2["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
  HttpStatusCode2[HttpStatusCode2["MULTI_STATUS"] = 207] = "MULTI_STATUS";
  HttpStatusCode2[HttpStatusCode2["ALREADY_REPORTED"] = 208] = "ALREADY_REPORTED";
  HttpStatusCode2[HttpStatusCode2["IM_USED"] = 226] = "IM_USED";
  HttpStatusCode2[HttpStatusCode2["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
  HttpStatusCode2[HttpStatusCode2["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
  HttpStatusCode2[HttpStatusCode2["FOUND"] = 302] = "FOUND";
  HttpStatusCode2[HttpStatusCode2["SEE_OTHER"] = 303] = "SEE_OTHER";
  HttpStatusCode2[HttpStatusCode2["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
  HttpStatusCode2[HttpStatusCode2["USE_PROXY"] = 305] = "USE_PROXY";
  HttpStatusCode2[HttpStatusCode2["SWITCH_PROXY"] = 306] = "SWITCH_PROXY";
  HttpStatusCode2[HttpStatusCode2["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
  HttpStatusCode2[HttpStatusCode2["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
  HttpStatusCode2[HttpStatusCode2["BAD_REQUEST"] = 400] = "BAD_REQUEST";
  HttpStatusCode2[HttpStatusCode2["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
  HttpStatusCode2[HttpStatusCode2["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["FORBIDDEN"] = 403] = "FORBIDDEN";
  HttpStatusCode2[HttpStatusCode2["NOT_FOUND"] = 404] = "NOT_FOUND";
  HttpStatusCode2[HttpStatusCode2["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
  HttpStatusCode2[HttpStatusCode2["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
  HttpStatusCode2[HttpStatusCode2["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
  HttpStatusCode2[HttpStatusCode2["CONFLICT"] = 409] = "CONFLICT";
  HttpStatusCode2[HttpStatusCode2["GONE"] = 410] = "GONE";
  HttpStatusCode2[HttpStatusCode2["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
  HttpStatusCode2[HttpStatusCode2["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
  HttpStatusCode2[HttpStatusCode2["URI_TOO_LONG"] = 414] = "URI_TOO_LONG";
  HttpStatusCode2[HttpStatusCode2["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
  HttpStatusCode2[HttpStatusCode2["RANGE_NOT_SATISFIABLE"] = 416] = "RANGE_NOT_SATISFIABLE";
  HttpStatusCode2[HttpStatusCode2["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
  HttpStatusCode2[HttpStatusCode2["I_AM_A_TEAPOT"] = 418] = "I_AM_A_TEAPOT";
  HttpStatusCode2[HttpStatusCode2["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
  HttpStatusCode2[HttpStatusCode2["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
  HttpStatusCode2[HttpStatusCode2["LOCKED"] = 423] = "LOCKED";
  HttpStatusCode2[HttpStatusCode2["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
  HttpStatusCode2[HttpStatusCode2["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
  HttpStatusCode2[HttpStatusCode2["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
  HttpStatusCode2[HttpStatusCode2["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
  HttpStatusCode2[HttpStatusCode2["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
  HttpStatusCode2[HttpStatusCode2["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
  HttpStatusCode2[HttpStatusCode2["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
  HttpStatusCode2[HttpStatusCode2["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
  HttpStatusCode2[HttpStatusCode2["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
  HttpStatusCode2[HttpStatusCode2["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
  HttpStatusCode2[HttpStatusCode2["VARIANT_ALSO_NEGOTIATES"] = 506] = "VARIANT_ALSO_NEGOTIATES";
  HttpStatusCode2[HttpStatusCode2["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
  HttpStatusCode2[HttpStatusCode2["LOOP_DETECTED"] = 508] = "LOOP_DETECTED";
  HttpStatusCode2[HttpStatusCode2["NOT_EXTENDED"] = 510] = "NOT_EXTENDED";
  HttpStatusCode2[HttpStatusCode2["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})(HttpStatusCode || (HttpStatusCode = {}));
var DateTemplates;
(function(DateTemplates2) {
  DateTemplates2["Days"] = "MMMM d";
  DateTemplates2["Long"] = "yyyy-MM-dd HH:mm:ss";
  DateTemplates2["Short"] = "yyyy-MM-dd";
})(DateTemplates || (DateTemplates = {}));
({
  isMac: (() => {
    try {
      return window.navigator.platform.toUpperCase().indexOf("MAC") >= 0;
    } catch {
      return false;
    }
  })()
});
new Intl.Collator(void 0, {
  numeric: true,
  sensitivity: "base"
}).compare;
function groupBy(iterable, key) {
  const map = /* @__PURE__ */ new Map();
  for (const t of iterable) {
    const groupKey = t[key];
    const group = map.get(groupKey);
    if (group) {
      group.push(t);
    } else {
      map.set(groupKey, [t]);
    }
  }
  return map;
}
const HIDDEN = "hidden";
function isParameterHidden(metadata, visibilityContext) {
  const visibility = metadata?.visibility;
  if (!visibility) return false;
  if (visibility === HIDDEN) return true;
  if (!visibilityContext) return false;
  return visibility.split(",").some((rule) => {
    const [context, state] = rule.trim().split(":");
    return context === visibilityContext && state === HIDDEN;
  });
}
const ORDER_LAST = 9999;
const _sfc_main$5 = defineComponent({
  name: "ParameterList",
  components: {
    QIcon
  },
  props: {
    advancedParamsClass: {
      default: void 0,
      type: [Array, Object, String]
    },
    groups: {
      default: () => [],
      type: Array
    },
    fields: {
      required: true,
      type: Array
    },
    groupId: {
      default: void 0,
      type: String
    },
    readonly: {
      default: false,
      type: Boolean
    },
    valueOnly: {
      default: false,
      type: Boolean
    },
    values: {
      default: void 0,
      type: Object
    },
    visibilityContext: {
      default: void 0,
      type: String
    }
  },
  emits: ["update:toggle"],
  setup(props) {
    const expanded = ref(false);
    const groupedParams = computed(() => groupBy(props.fields, "groupId"));
    const toggleParamKeys = computed(
      () => new Set(props.groups?.flatMap((g) => Object.keys(g.toggles ?? {})))
    );
    const allParams = computed(() => props.groupId ? groupedParams.value.get(props.groupId) : groupedParams.value.get(null));
    const visibleParams = computed(() => allParams.value?.filter(
      (p) => !isParameterHidden(p?.metadata, props.visibilityContext)
    ));
    const nonToggleParams = computed(() => visibleParams.value?.filter((p) => !toggleParamKeys.value.has(p.key)));
    const params = computed(() => nonToggleParams.value?.filter((p) => !isAdvanceParam(p)));
    const advancedParams = computed(() => nonToggleParams.value?.filter(isAdvanceParam));
    function getGroupOrder(group) {
      const idx = props.fields.findIndex((p) => p.groupId === group.id);
      return idx >= 0 ? idx : null;
    }
    function getOrder(v) {
      const idx = props.fields.indexOf(v);
      return idx >= 0 ? idx : null;
    }
    function isAdvanceParam(v) {
      return v?.metadata?.expertise === "advanced";
    }
    function getGroupToggle(group) {
      const toggleKey = Object.keys(group.toggles ?? {})[0];
      if (!toggleKey) return null;
      return props.fields.find(
        (p) => p.key === toggleKey && !isParameterHidden(p?.metadata, props.visibilityContext)
      );
    }
    function isGroupVisible(group) {
      const groupFields = groupedParams.value.get(group.id);
      const hasVisibleFields = groupFields?.some(
        (p) => !isParameterHidden(p?.metadata, props.visibilityContext)
      );
      const subGroups = group.subGroups ?? [];
      return hasVisibleFields || subGroups.some(isGroupVisible);
    }
    function isGroupContentVisible(group) {
      const toggle = getGroupToggle(group);
      if (!toggle) return true;
      const expectedValue = group.toggles?.[toggle.key];
      return props.values?.[toggle.key] === expectedValue;
    }
    return {
      advancedParams,
      expanded,
      getGroupOrder,
      getGroupToggle,
      getOrder,
      groupedParams,
      isGroupContentVisible,
      isGroupVisible,
      ORDER_LAST,
      params
    };
  }
});
const _hoisted_1$5 = { class: "row no-wrap items-baseline" };
const _hoisted_2$3 = {
  class: "text-subtitle3 q-pl-xs",
  style: { "white-space": "nowrap" }
};
const _hoisted_3 = ["data-automation"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
  const _component_rv_tooltip = resolveComponent("rv-tooltip");
  const _component_q_icon = resolveComponent("q-icon");
  const _component_ParameterList = resolveComponent("ParameterList", true);
  const _component_rv_expansion_item = resolveComponent("rv-expansion-item");
  return openBlock(), createElementBlock("div", normalizeProps(guardReactiveProps(_ctx.$attrs)), [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.groups, (group) => {
      return openBlock(), createElementBlock(Fragment, {
        key: group.id
      }, [
        _ctx.isGroupVisible(group) && _ctx.readonly && _ctx.getGroupToggle(group) && !_ctx.isGroupContentVisible(group) ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "row no-wrap items-baseline q-mb-sm",
          style: normalizeStyle({ order: _ctx.getGroupOrder(group) })
        }, [
          createVNode(_component_rv_ellipsis_text, {
            class: "text-body3",
            text: _ctx.getGroupToggle(group).name
          }, null, 8, ["text"]),
          createElementVNode("div", _hoisted_1$5, [
            createTextVNode(toDisplayString(_ctx.$t("rvai-params.general.symbols.colon")) + " ", 1),
            createElementVNode("span", _hoisted_2$3, toDisplayString(_ctx.$t("rvai-params.general.no")), 1)
          ])
        ], 4)) : _ctx.isGroupVisible(group) ? (openBlock(), createBlock(_component_rv_expansion_item, {
          key: 1,
          border: "",
          class: "q-mb-sm",
          "content-class": {
            "q-mt-sm": _ctx.readonly && !group.description,
            "q-pt-md": !_ctx.readonly && !group.description,
            "q-pt-sm": group.description
          },
          "data-automation": _ctx.getGroupToggle(group) ? `parameter-list__group-toggle__${_ctx.getGroupToggle(group).key}` : void 0,
          "default-opened": !_ctx.getGroupToggle(group),
          label: _ctx.getGroupToggle(group)?.name ?? group.name,
          "model-value": _ctx.isGroupContentVisible(group),
          style: normalizeStyle({ order: _ctx.getGroupOrder(group) }),
          "use-toggle": !!_ctx.getGroupToggle(group) && !_ctx.readonly && !_ctx.valueOnly,
          "onUpdate:modelValue": ($event) => _ctx.getGroupToggle(group) && _ctx.$emit("update:toggle", _ctx.getGroupToggle(group).key, $event)
        }, createSlots({
          default: withCtx(() => [
            group.description ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: "text-small text-grey-1 q-mb-sm",
              "data-automation": `parameter-list__group__${group.id}__description`
            }, toDisplayString(group.description), 9, _hoisted_3)) : createCommentVNode("", true),
            createVNode(_component_ParameterList, mergeProps({ ref_for: true }, _ctx.$attrs, {
              fields: _ctx.fields,
              "group-id": group.id,
              groups: group.subGroups,
              readonly: _ctx.readonly,
              "value-only": _ctx.valueOnly,
              values: _ctx.values,
              "visibility-context": _ctx.visibilityContext,
              "onUpdate:toggle": _cache[0] || (_cache[0] = (key, value) => _ctx.$emit("update:toggle", key, value))
            }), {
              param: withCtx(({ param: nested }) => [
                createElementVNode("div", {
                  style: normalizeStyle({ order: _ctx.getOrder(nested) })
                }, [
                  renderSlot(_ctx.$slots, "param", { param: nested })
                ], 4)
              ]),
              _: 3
            }, 16, ["fields", "group-id", "groups", "readonly", "value-only", "values", "visibility-context"])
          ]),
          _: 2
        }, [
          _ctx.getGroupToggle(group) ? {
            name: "label",
            fn: withCtx(() => [
              createVNode(_component_rv_ellipsis_text, {
                class: "zero-min-width",
                text: _ctx.getGroupToggle(group).name
              }, null, 8, ["text"]),
              _ctx.getGroupToggle(group)?.description ? (openBlock(), createBlock(_component_q_icon, {
                key: 0,
                class: "q-ml-xs cursor-pointer",
                color: "black-1",
                name: "info",
                size: "16px"
              }, {
                default: withCtx(() => [
                  createVNode(_component_rv_tooltip, null, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(_ctx.getGroupToggle(group).description), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)) : createCommentVNode("", true)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["content-class", "data-automation", "default-opened", "label", "model-value", "style", "use-toggle", "onUpdate:modelValue"])) : createCommentVNode("", true)
      ], 64);
    }), 128)),
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.params, (param) => {
      return openBlock(), createElementBlock("div", {
        key: param.key,
        style: normalizeStyle({ order: _ctx.getOrder(param) })
      }, [
        renderSlot(_ctx.$slots, "param", { param })
      ], 4);
    }), 128)),
    _ctx.advancedParams?.length ? (openBlock(), createBlock(_component_rv_expansion_item, {
      key: 0,
      modelValue: _ctx.expanded,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.expanded = $event),
      class: normalizeClass(["advanced-parameters q-pa-md border-card rounded-borders", { "q-mt-sm": _ctx.readonly }]),
      "content-class": _ctx.advancedParamsClass,
      "header-class": { "q-mb-md": _ctx.expanded && !_ctx.readonly },
      style: normalizeStyle({ order: _ctx.ORDER_LAST })
    }, {
      label: withCtx(() => [
        createVNode(_component_rv_ellipsis_text, {
          class: "zero-min-width text-subtitle3",
          text: _ctx.$t("rvai-params.general.text.advancedParams")
        }, null, 8, ["text"])
      ]),
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.advancedParams, (param) => {
          return openBlock(), createElementBlock("div", {
            key: param.key,
            style: normalizeStyle({ order: _ctx.getOrder(param) })
          }, [
            renderSlot(_ctx.$slots, "param", { param })
          ], 4);
        }), 128))
      ]),
      _: 3
    }, 8, ["modelValue", "class", "content-class", "header-class", "style"])) : createCommentVNode("", true)
  ], 16);
}
const ParameterList = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render]]);
const componentProps = {
  definition: {
    required: true,
    type: Object
  },
  disable: {
    default: false,
    type: Boolean
  },
  modelValue: {
    default: void 0,
    type: [Number, Object, String, Boolean]
  },
  /**
   * Daemon parameter requires project to be known.
   *
   * If it is not provided, the daemon parameter loads the project
   * based on the projectName route parameter.
   */
  project: {
    default: void 0,
    type: Object
  },
  readonly: {
    default: false,
    type: Boolean
  },
  valueOnly: {
    default: false,
    type: Boolean
  }
};
function generateName(baseName, names, separator = "-", useBrackets = false) {
  if (!names.includes(baseName)) return baseName;
  const regex = new RegExp(`(.+?)(?:(${separator}\\d+)|$)`);
  const match = baseName.match(regex);
  const prefix = match ? match[1] ?? "" : baseName;
  let index = 1;
  let name = "";
  do {
    name = index === 1 ? prefix : `${prefix}${separator}${useBrackets ? `(${index})` : index}`;
    ++index;
  } while (names.includes(name));
  return name;
}
var AreaMeasurementOperator = /* @__PURE__ */ ((AreaMeasurementOperator2) => {
  AreaMeasurementOperator2["BETWEEN"] = "between";
  AreaMeasurementOperator2["GTE"] = "gte";
  AreaMeasurementOperator2["LTE"] = "lte";
  return AreaMeasurementOperator2;
})(AreaMeasurementOperator || {});
const AREA_MEASUREMENT_VALUE_MIN = 1;
function getEmptyThreshold(existingNames) {
  return {
    classes: [],
    id: v4(),
    include_in_sampling: false,
    measurement_metadata: void 0,
    name: generateName("Threshold", existingNames),
    operator: void 0,
    value: void 0
  };
}
const _hoisted_1$4 = ["data-automation"];
const _hoisted_2$2 = ["data-automation"];
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "AreaMeasurementReadOnlyItem",
  props: {
    threshold: {}
  },
  setup(__props) {
    const props = __props;
    const { t } = useI18n();
    const operatorValueLabel = computed(() => {
      switch (props.threshold.operator) {
        case AreaMeasurementOperator.BETWEEN:
          return t(
            "rvai-params.areaMeasurement.operatorValue.between",
            [formatPixels(props.threshold.value_min), formatPixels(props.threshold.value_max)]
          );
        case AreaMeasurementOperator.GTE:
          return t(
            "rvai-params.areaMeasurement.operatorValue.gte",
            [formatPixels(props.threshold.value)]
          );
        case AreaMeasurementOperator.LTE:
          return t(
            "rvai-params.areaMeasurement.operatorValue.lte",
            [formatPixels(props.threshold.value)]
          );
        default:
          return "";
      }
    });
    const fields = computed(() => [
      {
        key: "classes",
        label: `${t("rvai-params.areaMeasurement.fields.classes")}${t("rvai-params.general.symbols.colon")}`,
        value: props.threshold.classes.join(", ")
      },
      {
        key: "value",
        label: `${t("rvai-params.areaMeasurement.fields.value")}${t("rvai-params.general.symbols.colon")}`,
        value: operatorValueLabel.value
      },
      {
        key: "measurement-metadata",
        label: `${t("rvai-params.areaMeasurement.fields.measurementMetadata")}${t("rvai-params.general.symbols.colon")}`,
        value: props.threshold.measurement_metadata ?? t("rvai-params.general.none")
      },
      {
        key: "include-in-sampling",
        label: `${t("rvai-params.areaMeasurement.fields.includeInSampling")}${t("rvai-params.general.symbols.colon")}`,
        value: props.threshold.include_in_sampling ? t("rvai-params.general.yes") : t("rvai-params.general.no")
      }
    ]);
    function formatPixels(value) {
      return `${value}px`;
    }
    return (_ctx, _cache) => {
      const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
      const _component_rv_expansion_item = resolveComponent("rv-expansion-item");
      return openBlock(), createBlock(_component_rv_expansion_item, {
        class: "bg-grey-5 q-pa-md zero-min-width full-width rounded-borders",
        "data-automation": `area-measurement-read-only-item-${__props.threshold.id}`,
        "default-opened": "",
        label: __props.threshold.name,
        "label-tooltip-class": "area-measurement-read-only-item-tooltip"
      }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(fields.value, (field) => {
            return openBlock(), createElementBlock("div", {
              key: field.key,
              class: "row no-wrap text-body3 text-black-1 text-no-wrap",
              "data-automation": `area-measurement-read-only-item__${field.key}`
            }, [
              createElementVNode("span", {
                "data-automation": `area-measurement-read-only-item__${field.key}__label`
              }, toDisplayString(field.label), 9, _hoisted_2$2),
              _cache[0] || (_cache[0] = createTextVNode("   ", -1)),
              createVNode(_component_rv_ellipsis_text, {
                class: "text-bold",
                "data-automation": `area-measurement-read-only-item__${field.key}__value`,
                text: field.value,
                "tooltip-class": "area-measurement-read-only-item-tooltip"
              }, null, 8, ["data-automation", "text"])
            ], 8, _hoisted_1$4);
          }), 128))
        ]),
        _: 1
      }, 8, ["data-automation", "label"]);
    };
  }
});
const _hoisted_1$3 = {
  key: 0,
  class: "column q-gutter-y-md",
  "data-automation": "area-measurement-read-only"
};
const _hoisted_2$1 = {
  key: 1,
  class: "text-body3 text-black-1 text-center",
  "data-automation": "area-measurement-read-only__no-thresholds"
};
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "AreaMeasurementReadOnly",
  props: {
    thresholds: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return __props.thresholds.length !== 0 ? (openBlock(), createElementBlock("div", _hoisted_1$3, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(__props.thresholds, (threshold) => {
          return openBlock(), createBlock(_sfc_main$4, {
            key: threshold.id,
            threshold
          }, null, 8, ["threshold"]);
        }), 128))
      ])) : (openBlock(), createElementBlock("div", _hoisted_2$1, toDisplayString(_ctx.$t("rvai-params.general.symbols.dash")), 1));
    };
  }
});
const _hoisted_1$2 = { "data-automation": "area-measurement-form" };
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "AreaMeasurementForm",
  props: {
    classes: {},
    threshold: {},
    validation: {}
  },
  emits: ["update"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const v$ = computed(() => props.validation);
    const emit = __emit;
    const { t } = useI18n();
    const betweenThreshold = computed(() => {
      if (props.threshold.operator === AreaMeasurementOperator.BETWEEN) {
        return props.threshold;
      }
      return null;
    });
    const singleValueThreshold = computed(() => {
      if (props.threshold.operator !== AreaMeasurementOperator.BETWEEN) {
        return props.threshold;
      }
      return null;
    });
    const isOperatorDisabled = computed(() => {
      return props.threshold.classes.length === 0;
    });
    const isValueDisabled = computed(() => {
      return isOperatorDisabled.value || !props.threshold.operator;
    });
    const isThresholdValueMissing = computed(() => {
      if (betweenThreshold.value) {
        return isValueDisabled.value || !betweenThreshold.value.value_min || !betweenThreshold.value.value_max;
      }
      return isValueDisabled.value || !singleValueThreshold.value?.value;
    });
    const operatorOptions = computed(() => [
      {
        label: t("rvai-params.areaMeasurement.operators.gte"),
        value: AreaMeasurementOperator.GTE
      },
      {
        label: t("rvai-params.areaMeasurement.operators.lte"),
        value: AreaMeasurementOperator.LTE
      },
      {
        label: t("rvai-params.areaMeasurement.operators.between"),
        value: AreaMeasurementOperator.BETWEEN
      }
    ]);
    function onOperatorChange(updatedOperator) {
      const thresholdToUpdate = { ...props.threshold };
      if (updatedOperator === AreaMeasurementOperator.BETWEEN) {
        if ("value" in thresholdToUpdate) {
          delete thresholdToUpdate.value;
        }
        emit("update", Object.assign(thresholdToUpdate, {
          operator: updatedOperator,
          value_max: void 0,
          value_min: void 0
        }));
        return;
      }
      if ("value_max" in thresholdToUpdate) {
        delete thresholdToUpdate.value_max;
      }
      if ("value_min" in thresholdToUpdate) {
        delete thresholdToUpdate.value_min;
      }
      emit("update", {
        ...thresholdToUpdate,
        operator: updatedOperator,
        value: void 0
      });
    }
    function onChange(value) {
      const updatedThreshold = { ...props.threshold };
      emit("update", Object.assign(updatedThreshold, value));
    }
    return (_ctx, _cache) => {
      const _component_rv_multiple_select = resolveComponent("rv-multiple-select");
      const _component_rv_select = resolveComponent("rv-select");
      const _component_rv_input = resolveComponent("rv-input");
      const _component_rv_toggle = resolveComponent("rv-toggle");
      return openBlock(), createElementBlock("div", _hoisted_1$2, [
        createVNode(_component_rv_multiple_select, {
          class: "q-mt-md",
          "data-automation": "area-measurement-form__classes",
          label: _ctx.$t("rvai-params.areaMeasurement.fields.classes"),
          "model-value": __props.threshold.classes,
          options: Object.keys(__props.classes),
          validation: v$.value.classes,
          "with-chips": "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = (val) => onChange({ classes: val }))
        }, null, 8, ["label", "model-value", "options", "validation"]),
        createVNode(_component_rv_select, {
          class: "q-mt-md",
          "data-automation": "area-measurement-form__operator",
          disable: isOperatorDisabled.value,
          label: _ctx.$t("rvai-params.areaMeasurement.fields.operator"),
          "map-options": "",
          "model-value": __props.threshold.operator,
          options: operatorOptions.value,
          placeholder: _ctx.$t("rvai-params.areaMeasurement.general.selectOption"),
          validation: v$.value.operator,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = (val) => onOperatorChange(val.value))
        }, null, 8, ["disable", "label", "model-value", "options", "placeholder", "validation"]),
        betweenThreshold.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createVNode(_component_rv_input, {
            class: "q-mt-md",
            "data-automation": "area-measurement-form__value-min",
            disable: isValueDisabled.value,
            hint: _ctx.$t("rvai-params.areaMeasurement.fields.valueHint"),
            label: _ctx.$t("rvai-params.areaMeasurement.fields.minValueLabel"),
            min: unref(AREA_MEASUREMENT_VALUE_MIN),
            "model-value": betweenThreshold.value.value_min,
            type: "number",
            validation: v$.value.value_min,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = (val) => onChange({ value_min: Number(val) }))
          }, null, 8, ["disable", "hint", "label", "min", "model-value", "validation"]),
          createVNode(_component_rv_input, {
            class: "q-mt-sm",
            "data-automation": "area-measurement-form__value-max",
            disable: isValueDisabled.value,
            hint: _ctx.$t("rvai-params.areaMeasurement.fields.valueHint"),
            label: _ctx.$t("rvai-params.areaMeasurement.fields.maxValueLabel"),
            min: unref(AREA_MEASUREMENT_VALUE_MIN),
            "model-value": betweenThreshold.value.value_max,
            type: "number",
            validation: v$.value.value_max,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = (val) => onChange({ value_max: Number(val) }))
          }, null, 8, ["disable", "hint", "label", "min", "model-value", "validation"])
        ], 64)) : (openBlock(), createBlock(_component_rv_input, {
          key: 1,
          class: "q-mt-md",
          "data-automation": "area-measurement-form__value",
          disable: isValueDisabled.value,
          hint: _ctx.$t("rvai-params.areaMeasurement.fields.valueHint"),
          label: _ctx.$t("rvai-params.areaMeasurement.fields.valueLabel"),
          min: unref(AREA_MEASUREMENT_VALUE_MIN),
          "model-value": singleValueThreshold.value?.value,
          type: "number",
          validation: v$.value.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = (val) => onChange({ value: Number(val) }))
        }, null, 8, ["disable", "hint", "label", "min", "model-value", "validation"])),
        createVNode(_component_rv_input, {
          class: "q-mt-sm",
          "data-automation": "area-measurement-form__measurement-metadata",
          disable: isThresholdValueMissing.value,
          "info-text": _ctx.$t("rvai-params.areaMeasurement.fields.measurementMetadataInfoText"),
          label: _ctx.$t("rvai-params.areaMeasurement.fields.measurementMetadata"),
          "model-value": __props.threshold.measurement_metadata,
          "show-optional-label": "",
          validation: v$.value.measurement_metadata,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = (val) => onChange({ measurement_metadata: val }))
        }, null, 8, ["disable", "info-text", "label", "model-value", "validation"]),
        createVNode(_component_rv_toggle, {
          class: "q-mt-md",
          "data-automation": "area-measurement-form__include-in-sampling",
          disable: isThresholdValueMissing.value,
          "info-text": _ctx.$t("rvai-params.areaMeasurement.fields.includeInSamplingInfoText"),
          label: _ctx.$t("rvai-params.areaMeasurement.fields.includeInSampling"),
          "model-value": __props.threshold.include_in_sampling,
          validation: v$.value.include_in_sampling,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = (val) => onChange({ include_in_sampling: val }))
        }, null, 8, ["disable", "info-text", "label", "model-value", "validation"])
      ]);
    };
  }
});
const _hoisted_1$1 = { class: "row items-center justify-between full-width no-wrap" };
const _hoisted_2 = { class: "min-width-0 overflow-hidden q-pr-sm flex-grow" };
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "AreaMeasurementThreshold",
  props: {
    classes: {},
    deleteDisabled: { type: Boolean },
    existingNames: {},
    threshold: {}
  },
  emits: ["delete", "update", "update:name"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const expanded = ref(true);
    const existingNamesRef = computed(() => props.existingNames);
    const betweenThreshold = computed(() => {
      if (props.threshold.operator === AreaMeasurementOperator.BETWEEN) {
        return props.threshold;
      }
      return null;
    });
    const singleValueThreshold = computed(() => {
      if (props.threshold.operator !== AreaMeasurementOperator.BETWEEN) {
        return props.threshold;
      }
      return null;
    });
    const nameValidationRules = ValidationBuilder.$t("rvai-params.areaMeasurement.general.name").required.wordsWithSpaces.maxLength(255).uniqueValue(existingNamesRef).rules;
    const formValidationRules = computed(() => {
      const baseRules = {
        classes: ValidationBuilder.$t("rvai-params.areaMeasurement.fields.classes").custom(
          (value) => value.length > 0,
          "rvai-params.errors.selectionRequired"
        ).rules,
        include_in_sampling: ValidationBuilder.$t("rvai-params.areaMeasurement.fields.includeInSampling").required.rules,
        measurement_metadata: ValidationBuilder.$t("rvai-params.areaMeasurement.fields.measurementMetadata").wordsWithSpaces.maxLength(255).rules,
        operator: ValidationBuilder.$t("rvai-params.areaMeasurement.fields.operator").required.rules
      };
      if (betweenThreshold.value) {
        return {
          ...baseRules,
          value_max: ValidationBuilder.$t("rvai-params.areaMeasurement.fields.value").required.numbersOnly.minValue(AREA_MEASUREMENT_VALUE_MIN).custom(
            (value) => value > (betweenThreshold.value?.value_min ?? 0),
            "rvai-params.areaMeasurement.fields.valueGreaterThan"
          ).rules,
          value_min: ValidationBuilder.$t("rvai-params.areaMeasurement.fields.value").required.numbersOnly.minValue(AREA_MEASUREMENT_VALUE_MIN).rules
        };
      } else {
        return {
          ...baseRules,
          value: ValidationBuilder.$t("rvai-params.areaMeasurement.fields.value").required.numbersOnly.minValue(AREA_MEASUREMENT_VALUE_MIN).rules
        };
      }
    });
    const formValidationState = computed(() => {
      const baseState = {
        classes: props.threshold.classes,
        include_in_sampling: props.threshold.include_in_sampling,
        measurement_metadata: props.threshold.measurement_metadata,
        operator: props.threshold.operator
      };
      if (betweenThreshold.value) {
        return {
          ...baseState,
          value_max: betweenThreshold.value.value_max,
          value_min: betweenThreshold.value.value_min
        };
      }
      return {
        ...baseState,
        value: singleValueThreshold.value?.value
      };
    });
    const formValidation = useVuelidate(formValidationRules, computed(() => formValidationState.value));
    const emit = __emit;
    const nameRef = useTemplateRef("nameRef");
    const shouldEditNameAfterMenuHide = ref(false);
    function onNameClick(event) {
      if (nameRef.value?.editing) {
        event.stopPropagation();
        event.preventDefault();
      }
    }
    function onEditThreshold() {
      shouldEditNameAfterMenuHide.value = true;
    }
    function onMenuHide() {
      if (!shouldEditNameAfterMenuHide.value) return;
      shouldEditNameAfterMenuHide.value = false;
      nameRef.value?.edit();
    }
    function onUpdateName(updatedName) {
      if (!updatedName) return;
      emit("update:name", updatedName);
    }
    return (_ctx, _cache) => {
      const _component_rv_editable_text = resolveComponent("rv-editable-text");
      const _component_rv_button = resolveComponent("rv-button");
      const _component_rv_expansion_item = resolveComponent("rv-expansion-item");
      return openBlock(), createBlock(_component_rv_expansion_item, {
        modelValue: expanded.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => expanded.value = $event),
        border: "",
        class: "q-mt-md",
        "data-automation": "area-measurement-threshold",
        "default-opened": "",
        label: __props.threshold.name,
        "no-hover-animation": ""
      }, {
        label: withCtx(() => [
          createElementVNode("div", _hoisted_1$1, [
            createElementVNode("div", _hoisted_2, [
              createVNode(_component_rv_editable_text, {
                ref_key: "nameRef",
                ref: nameRef,
                class: "text-black-1 area-measurement-threshold__name",
                "data-automation": "area-measurement-threshold__name",
                "model-value": __props.threshold.name,
                "validation-rules": unref(nameValidationRules),
                onClick: onNameClick,
                "onUpdate:modelValue": onUpdateName
              }, null, 8, ["model-value", "validation-rules"])
            ]),
            createVNode(_component_rv_button, {
              class: "flex-shrink-0",
              color: "grey-1",
              "data-automation": "area-measurement-threshold__menu",
              icon: "mdi-dots-horizontal",
              tertiary: "",
              onClick: _cache[1] || (_cache[1] = withModifiers(() => {
              }, ["prevent", "stop"]))
            }, {
              default: withCtx(() => [
                createVNode(unref(QMenu), {
                  anchor: expanded.value ? "bottom left" : "top left",
                  "auto-close": "",
                  "max-height": "81px",
                  self: "top left",
                  onHide: onMenuHide
                }, {
                  default: withCtx(() => [
                    createVNode(unref(QList), { separator: "" }, {
                      default: withCtx(() => [
                        createVNode(unref(QItem), {
                          clickable: "",
                          "data-automation": "area-measurement-threshold__edit",
                          onClick: onEditThreshold
                        }, {
                          default: withCtx(() => [
                            createVNode(unref(QItemLabel), null, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString(_ctx.$t("rvai-params.areaMeasurement.general.edit")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        createVNode(unref(QItem), {
                          clickable: "",
                          "data-automation": "area-measurement-threshold__delete",
                          disable: __props.deleteDisabled,
                          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("delete"))
                        }, {
                          default: withCtx(() => [
                            createVNode(unref(QItemLabel), null, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString(_ctx.$t("rvai-params.areaMeasurement.general.delete")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disable"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["anchor"])
              ]),
              _: 1
            })
          ])
        ]),
        default: withCtx(() => [
          createVNode(_sfc_main$2, {
            classes: __props.classes,
            threshold: __props.threshold,
            validation: unref(formValidation),
            onUpdate: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("update", $event))
          }, null, 8, ["classes", "threshold", "validation"])
        ]),
        _: 1
      }, 8, ["modelValue", "label"]);
    };
  }
});
const AreaMeasurementThresholdItem = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["__scopeId", "data-v-b0e69ebd"]]);
const _hoisted_1 = {
  key: 1,
  "data-automation": "area-measurement"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AreaMeasurement",
  props: /* @__PURE__ */ mergeModels({
    classes: {},
    readOnly: { type: Boolean, default: false }
  }, {
    "modelValue": {
      required: true
    },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const modelValue = useModel(__props, "modelValue");
    const v$ = useVuelidate();
    const currentModelValue = ref(
      modelValue.value.length === 0 ? [getEmptyThreshold([])] : modelValue.value
    );
    function emitModelValue() {
      void nextTick(() => {
        modelValue.value = v$.value.$invalid ? [] : currentModelValue.value;
      });
    }
    function updateThreshold(updatedThreshold) {
      currentModelValue.value = currentModelValue.value.map((threshold) => {
        return threshold.id === updatedThreshold.id ? updatedThreshold : threshold;
      });
      emitModelValue();
    }
    function onAddThreshold() {
      const existingNames = currentModelValue.value.map((rule) => rule.name);
      currentModelValue.value = [
        ...currentModelValue.value,
        getEmptyThreshold(existingNames)
      ];
      emitModelValue();
    }
    function onDeleteThreshold(threshold) {
      currentModelValue.value = currentModelValue.value.filter((rule) => rule.id !== threshold.id);
      emitModelValue();
    }
    function onUpdateThresholdName(changedName, thresholdToUpdate) {
      currentModelValue.value = currentModelValue.value.map((threshold) => {
        if (threshold.id === thresholdToUpdate.id) {
          return {
            ...threshold,
            name: changedName
          };
        }
        return threshold;
      });
      emitModelValue();
    }
    return (_ctx, _cache) => {
      const _component_rv_button = resolveComponent("rv-button");
      return __props.readOnly ? (openBlock(), createBlock(_sfc_main$3, {
        key: 0,
        thresholds: modelValue.value
      }, null, 8, ["thresholds"])) : (openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(_component_rv_button, {
          class: "full-width",
          "data-automation": "area-measurement__add-threshold",
          label: _ctx.$t("rvai-params.areaMeasurement.general.addThreshold"),
          secondary: "",
          size: "sm",
          onClick: onAddThreshold
        }, null, 8, ["label"]),
        (openBlock(true), createElementBlock(Fragment, null, renderList(currentModelValue.value, (threshold) => {
          return openBlock(), createBlock(AreaMeasurementThresholdItem, {
            key: threshold.id,
            classes: __props.classes,
            "delete-disabled": currentModelValue.value.length === 1,
            "existing-names": currentModelValue.value.filter((t) => t.id !== threshold.id).map((t) => t.name),
            threshold,
            onDelete: ($event) => onDeleteThreshold(threshold),
            onUpdate: updateThreshold,
            "onUpdate:name": ($event) => onUpdateThresholdName($event, threshold)
          }, null, 8, ["classes", "delete-disabled", "existing-names", "threshold", "onDelete", "onUpdate:name"]);
        }), 128))
      ]));
    };
  }
});
const components = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AreaMeasurement: _sfc_main,
  ParamTitle,
  Parameter: _sfc_main$6,
  ParameterList,
  ReadOnlyParam
}, Symbol.toStringTag, { value: "Module" }));
const newMessages = {
  "rvai-params": {
    areaMeasurement: {
      fields: {
        classes: "Classes",
        includeInSampling: "Include in sampling",
        includeInSamplingInfoText: "Use this measurement as a sampling condition during inference. When enabled, recording occurs even if no other sampling conditions are satisfied.",
        measurementMetadata: "Measurement metadata",
        measurementMetadataInfoText: "Add metadata to describe the origin or context of this measurement in the imported data.",
        minValueLabel: "Minimum value (px)",
        maxValueLabel: "Maximum value (px)",
        operator: "Operator",
        value: "Value",
        valueLabel: "Value (px)",
        valueHint: "Value must contain only numbers",
        valueGreaterThan: "This value must be greater than the first value."
      },
      general: {
        addThreshold: "Add new threshold",
        "delete": "Delete",
        edit: "Edit",
        name: "Name",
        selectOption: "Select option"
      },
      operators: {
        between: "is between (inclusive)",
        gte: "is greater than or equal to",
        lte: "is less than or equal to"
      },
      operatorValue: {
        between: "is between {0} - {1}",
        gte: "is greater than or equal to {0}",
        lte: "is less than or equal to {0}"
      }
    },
    errors: {
      bothAreRequired: "Both key and value are required",
      duplicatedKeys: "Keys should be unique",
      selectionRequired: "This field requires at least one selection"
    },
    general: {
      allSelected: "All selected",
      key: "key",
      no: "No",
      none: "None",
      text: {
        advancedParams: "Advanced parameters"
      },
      symbols: {
        colon: ":",
        dash: "-"
      },
      unset: "Unset",
      value: "value",
      yes: "Yes"
    }
  }
};
function initializeI18n() {
  const i18n = useI18n();
  i18n.mergeLocaleMessage("en", newMessages);
}
function initialize(options) {
  initializeI18n();
  provideOptions(options);
}
const PREFIX = "Rv";
const install = function(app) {
  Object.entries(components).forEach(([name, component]) => {
    app.component(`${PREFIX}${name}`, component);
  });
};
const plugin = { install };
export {
  AREA_MEASUREMENT_VALUE_MIN,
  _sfc_main as AreaMeasurement,
  AreaMeasurementOperator,
  ParamTitle,
  _sfc_main$6 as Parameter,
  ParameterList,
  ReadOnlyParam,
  componentProps,
  plugin as default,
  generateName,
  getEmptyThreshold,
  initialize,
  isParameterHidden,
  provideOptions,
  useOptions
};
//# sourceMappingURL=index.es.js.map
